(function() {
  function attachListeners() {
    document.querySelectorAll('a').forEach(function(link) {
      const text = link.textContent.trim().toLowerCase();
      if (
        text.includes('join the skin club') ||
        text.includes('create free account') ||
        text.includes('already a member') ||
        text.includes('already collecting') ||
        text.includes('sign in')
      ) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          if (text.includes('sign in') || text.includes('already')) {
            window.location.href = '/account/login?return_url=/pages/skin-club';
          } else {
            window.location.href = '/account/register?return_url=/pages/skin-club';
          }
        });
      }
    });
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }
})();
